var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 2.58337H14.7917C11.4583 2.58337 9.375 4.66671 9.375 8.00004V12.2188H15.8854C16.3125 12.2188 16.6667 12.573 16.6667 13C16.6667 13.4271 16.3125 13.7813 15.8854 13.7813H9.375V18C9.375 21.3334 11.4583 23.4167 14.7917 23.4167H17.4896C20.8229 23.4167 22.9062 21.3334 22.9062 18V8.00004C22.9167 4.66671 20.8333 2.58337 17.5 2.58337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.75146 12.2185L6.90771 10.0623C7.06396 9.90605 7.13688 9.70813 7.13688 9.51021C7.13688 9.3123 7.06396 9.10396 6.90771 8.95813C6.60563 8.65605 6.10563 8.65605 5.80355 8.95813L2.31396 12.4477C2.01188 12.7498 2.01188 13.2498 2.31396 13.5518L5.80355 17.0414C6.10563 17.3435 6.60563 17.3435 6.90771 17.0414C7.2098 16.7393 7.2098 16.2393 6.90771 15.9373L4.75146 13.781H9.37646V12.2185H4.75146Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1988275cad5b434b2917adef358f6e0a.svg";
export { ForwardRef as ReactComponent };